const items = Object.freeze({
  Equipment: 0,
  Book: 1
});
export default items;
